import React, { Component } from 'react';
import cn from 'classnames';
import styles from './PopUp.scss';

import ScrollLock from 'components/ScrollLock';

import iconCloseGallery from 'assets/images/icons/close.svg';
import iconCloseDefault from 'assets/images/icons/cross.svg';

import { setPopUp } from 'actions/environment';

class PopUp extends Component {
  constructor(props) {
    super(props);

    this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
  }

  handleBackgroundClick(event) {
    const { onBackgroundClick, dispatch } = this.props;

    dispatch(setPopUp(undefined));

    if (onBackgroundClick) {
      onBackgroundClick();
    }
  }

  render() {
    const { className, backgroundClassName, contentClassName, closeIcon, closeClassName, closeStyleName, content, contentStyleName, lockScroll = true } = this.props;
    let iconClose;
    switch (closeIcon) {
      case 'default':
        iconClose = iconCloseDefault;
        break;
      case 'gallery':
        iconClose = iconCloseGallery;
        break;
      default:
        iconClose = iconCloseDefault;
    }
    return (
      <div className={cn(styles.PopUp, className)}>
        <div className={cn(styles.Background, backgroundClassName)}>
          <div className={styles.BackgroundOverlay} onClick={this.handleBackgroundClick}></div>
          <div className={cn(styles.Content, styles[contentStyleName], contentClassName)}>
            { content &&
              (
                lockScroll ?
                  <ScrollLock>
                    {content}
                  </ScrollLock>
                : content
              )
            }
            {(closeIcon == 'default') ? (
              <div className={cn(styles.Close, styles[closeStyleName], closeClassName)} onClick={this.handleBackgroundClick}>
                <img alt="close" src={iconClose} />
              </div>
            ) : null}
          </div>
          {(closeIcon != 'default') ? (
            <div className={cn(styles.Close, styles[closeStyleName], closeClassName)} onClick={this.handleBackgroundClick}>
              <img alt="close" src={iconClose} />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default PopUp;



// WEBPACK FOOTER //
// ./src/containers/PopUp/PopUp.js